
interface MetaData {
    title: string;
    description: string;
    robots?: string;
    canonical?: string;
    og?: {
        locale?: string,
        type?: string,
        title?: string,
        description?: string,
        url?: string,
        site_name?: string,
        updated_time?: string,
        image?: string,
        image_secure_url?: string,
        image_width?: number,
        image_height?: number,
        image_alt?: string,
        image_type?: string,
        video?: string,
        video_duration?: number,
        video_upload_date?: string,
        video_allow_embed?: boolean,
    };
    twitter?: {
        card?: string,
        title?: string,
        description?: string,
        image?: string,
    };
}

interface Step {
    title: string;
    desc: string;
    icon: string;
}

interface ProcedureSteps {
    heading: string;
    para: string;
    steps: Step[];
}

interface ListItem {
    title: string;
    desc: string;
    icon: string;
}

interface ListSection {
    heading?: string;
    subheading?: string;
    para?: string;
    items: ListItem[];
}

interface ingredients {
    heading?: string;
    subheading?: string;
    para?: string;
    items: ListItem[];
}

interface FAQItem {
    question: string;
    answer: string;
}

interface FAQSection {
    heading?: string;
    subheading?: string;
    items: FAQItem[];
}

interface HeroSection {
    title: string;
    subtitle: string;
    description: string;
}

interface HowItWorks {
    title: string;
    description: string;
    items: any;
}

interface TreatmentArea {
    ar: string;
    title: string;
    image: string;
}

interface LanguageContent {
    url?: string; // Added url property
    meta: MetaData;
    breadcrumbs: string[];
    hero: HeroSection;
    howItWorks: HowItWorks;
    procedureSteps: ProcedureSteps;
    benefits: ListSection;
    eligibility: ListSection;
    preparationTips: ListSection;
    results: ListSection;
    aftercareTips: ListSection;
    faqData: FAQSection;
    // ingredients: ingredients;
    // treatmentAreas1: TreatmentArea[];
    // treatmentAreas2: TreatmentArea[];
}

interface SharedData {
    images: {
        main: string,
        beforeAfter: string[] | any,
        introductionImage?: string,
    };
    product: {
        id: number,
        title: string,
        price: number,
        description: string,
    };
}

export const generalcheckup: {
    en: LanguageContent,
    ar: LanguageContent,
    shared: SharedData,
} =
{
    "en": {
        "url": "general-health-check-up",
        "meta": {
            "title": "General Health Check Up Package Dubai | Elite Body Home",
            "description": "Comprehensive health screening package including blood tests, urine analysis, and vital sign checks for early detection of health issues and preventive care.",
            "robots": "index, follow",
            "canonical": "https://www.elitebodyhome.com/services/general-health-check-up/",
            "og": {
                "title": "General Health Check Up Package Dubai | Elite Body Home",
                "description": "Complete health assessment with blood tests and vital sign monitoring for preventive care",
                "image": "https://www.elitebodyhome.com/images/general-health-check-og.jpg"
            }
        },
        "breadcrumbs": ["Home", "Services", "General Health Check Up"],
        "hero": {
            "title": "General Health Check Up Package",
            "subtitle": "Your Health Comes First",
            "description": "Blood test is also part of a routine examination when you go for a general check-up. This blood test gives important information about your health status, allowing medical professionals to identify any possible medical problems at an early stage. You are also given regular check ups to increase your overall health, so that you can tackle a problem before it becomes a problem. Focus on your health with these regular appointments, leading to a long, healthy life."
        },
        "howItWorks": {
            "title": "General Check Up Package Inclusive List",
            "description": "Our comprehensive check-up includes a wide range of tests to give you a complete picture of your health status.",
            "items": [
                "PPBS – Glucose – Post Prandial (PPBS)82947",
                "HBA1C1 – Hemoglobin A1c,83236",
                "STOA – Stool Analysis, 87177",
                "Q039 URINE ANALYSIS, 81001",
                "UREA – Urea, 84520",
                "URAC – Uric Acid, 84550",
                "CREAT – Creatinine, 82565",
                "SOD – Sodium, 84295",
                "PM – Potassium, 84132",
                "CHLO – Chloride, 82435",
                "PROT – Protein – Total, 84155",
                "ALBU – Albumin, 82040",
                "GLB – Globulin, NA",
                "BILT – Bilirubin Total, 82247",
                "BILD – Bilirubin Direct (Conjugated), 82248",
                "CAL – Calcium, 82310",
                "PS – Phosphate, 84100",
                "Alkaline Phosphatase, 84075 (ALPH)",
                "ALT – ALT/SGPT (Alanine Aminotransferase), 84460",
                "AST – AST/SGOT (Aspartate Aminotransferase), 84450",
                "GGT – Gamma Glutamyl Transferase (GGT), 382094",
                "LPPROF – Lipid Profile, 0",
                "TSH1 – Thyroid Stimulating Hormone (TSH), 84443",
                "FT3 – FT3 (Tri-Iodothyronine-Free), 84481",
                "FT4 – FT4 (Thyroxine – Free), 84439",
                "AMPL – Amylase, 82150",
                "LPSE – Lipase, 83690",
                "BICBAT – Bicarbonate, 82374"
            ]
        },
        "procedureSteps": {
            "heading": "Procedure",
            "para": "There are several steps to a general check-up each of which measures different areas of health. During this process, they want to see if there are any signs of illness, to conduct preventive care and to instruct you on maintaining a healthy lifestyle.",
            "steps": [
                {
                    "title": "Consultation",
                    "desc": "Most ImportantlyTalk Over Medical History, Lifestyle, and Concerns With a Physician",
                    "icon": "fa-solid fa-comment-medical"
                },
                {
                    "title": "Physical Examination",
                    "desc": "Check general health (blood pressure, heart rate, BMI etc.).",
                    "icon": "fa-solid fa-stethoscope"
                },
                {
                    "title": "Laboratory Tests",
                    "desc": "Coverage of blood and urine tests including CBC, blood sugar, cholesterol, liver, kidney and thyroid function tests",
                    "icon": "fa-solid fa-flask"
                },
                {
                    "title": "Specialized Screenings",
                    "desc": "Diabetes, hypertension, or other lifestyle disease screenings.",
                    "icon": "fa-solid fa-search"
                },
                {
                    "title": "Personalized Health Plan",
                    "desc": "Create a suitable health plan depending on check up outcomes.",
                    "icon": "fa-solid fa-clipboard-list"
                },
                {
                    "title": "Diagnostic Imaging",
                    "desc": "Depending on what is found upon examination, you may be advised to have an X-ray, an ultrasound, or an ECG.",
                    "icon": "fa-solid fa-x-ray"
                },
                {
                    "title": "Discussion: Doctor's Review",
                    "desc": "Discuss test results with a doctor, get recommendations and explanations.",
                    "icon": "fa-solid fa-user-md"
                },
                {
                    "title": "Follow-Up",
                    "desc": "I May Order Additional Tests or Consultations If Needed",
                    "icon": "fa-solid fa-calendar-check"
                }
            ]
        },
        "benefits": {
            "heading": "Benefits",
            "subheading": "",
            "para": "A general check-up is essential as it provides various benefits that facilitate you with managing your health rather than letting it become a problem in the long run.",
            "items": [
                {
                    "title": "Early detection of diseases",
                    "desc": "Anticipate health problems such as heart disease, diabetes and cancer before they are serious.",
                    "icon": "fa-solid fa-earlybirds"
                },
                {
                    "title": "Preventive care",
                    "desc": "Cardiovascular disease: Chronic conditions are partly preventable and there are factors that can reduce the risk of chronic conditions.",
                    "icon": "fa-solid fa-shield-alt"
                },
                {
                    "title": "Personalized advice",
                    "desc": "Get advice on diet, exercise and stress management.",
                    "icon": "fa-solid fa-user-edit"
                },
                {
                    "title": "Peace of mind",
                    "desc": "Being informed about your health status alleviates anxiety levels and promotes proactive attitudes towards health.",
                    "icon": "fa-solid fa-smile"
                }
            ]
        },
        "eligibility": {
            "heading": "Eligibility",
            "subheading": "",
            "para": "Is General check up for everyone general check ups are appropriate for the vast majority of people but certain factors can influence how often, and what on they should come in for.",
            "items": [
                {
                    "title": "Adults",
                    "desc": "Adults should have a check-up every year, particularly for anyone older than 40.",
                    "icon": "fa-solid fa-user"
                },
                {
                    "title": "Children",
                    "desc": "Regular pediatric visits are necessary for growth and development tracking.",
                    "icon": "fa-solid fa-child"
                },
                {
                    "title": "Elderly individuals",
                    "desc": "Older adults may need more regular exams to help manage conditions such as high blood pressure, arthritis or vision problems.",
                    "icon": "fa-solid fa-wheelchair"
                },
                {
                    "title": "People with chronic conditions",
                    "desc": "If you have chronic conditions like diabetes or hypertension, you also need more frequent check-ups for health surveillance.",
                    "icon": "fa-solid fa-heartbeat"
                }
            ]
        },
        "preparationTips": {
            "heading": "Preparation",
            "subheading": "",
            "para": "Before attending a general check-up it is good to prepare so that everything goes smoothly and your health care provider has all the relevant information.",
            "items": [
                {
                    "title": "Fasting",
                    "desc": "Other tests, like glucose or cholesterol, may require you to fast for 8–12 hours prior to your appointment.",
                    "icon": "fa-solid fa-hourglass-half"
                },
                {
                    "title": "Bring medical records",
                    "desc": "Take your medical history with you, especially if you are seeing a new doctor.",
                    "icon": "fa-solid fa-folder-open"
                },
                {
                    "title": "List medications",
                    "desc": "List all medications, including supplements, so they can be included in your treatment plan.",
                    "icon": "fa-solid fa-prescription-bottle-alt"
                },
                {
                    "title": "Note down symptoms",
                    "desc": "If you have any lingering symptoms or concerns, be sure to bring them up at the check-up.",
                    "icon": "fa-solid fa-clipboard-list"
                }
            ]
        },
        "results": {
            "heading": "Results",
            "subheading": "",
            "para": "Your family physician will discuss result of your general check-up and further steps (if any).",
            "items": [
                {
                    "title": "Test results",
                    "desc": "You will be getting detailed reports of blood tests, scans, or any other diagnostics done in this check-up.",
                    "icon": "fa-solid fa-file-medical"
                },
                {
                    "title": "Health advice",
                    "desc": "Your doctor will provide recommendations to maintain (or improve) your health based on your results.",
                    "icon": "fa-solid fa-comment-medical"
                },
                {
                    "title": "Follow-up",
                    "desc": "You may have to make follow up appointments for testing or treatment if anything is detected as abnormal.",
                    "icon": "fa-solid fa-calendar-check"
                },
                {
                    "title": "Lifestyle recommendations",
                    "desc": "Customized guidance on diet, exercise and other habits to help you make the most of your well-being.",
                    "icon": "fa-solid fa-heart"
                }
            ]
        },
        "aftercareTips": {
            "heading": "General Health Check Performing Centres – Elite Body Home",
            "subheading": "",
            "para": "Elite Body Home always puts your health and well being first. We provide a wide range of personalized check-ups, performed by a specialized and experienced medical team. We perform comprehensive assessments—including vital sign checks, bloodwork, and consultations—to give you a complete view of your health. We provide speedy, accurate results utilizing state-of-the-art diagnostic equipment, allowing for early identification and prevention of potential health problems. Elite Body Home a perfect fit for receiving outstanding treatment on your health check-ups. You will be given personal advice to aid your health journey.",
            "items": []
        },
        "faqData": {
            "heading": "Frequently Asked Questions",
            "subheading": "",
            "items": [
                {
                    "question": "How often should I have a general check-up?",
                    "answer": "Adults are usually advised to have a check-up every year. However, the frequency can vary based on age, lifestyle, and existing health conditions."
                },
                {
                    "question": "What tests are done during a general check-up?",
                    "answer": "Basic tests often include blood tests, urine analysis, and screenings for diseases like cancer, diabetes, and heart disease."
                },
                {
                    "question": "Will I get my test results immediately?",
                    "answer": "Some tests, like blood pressure and BMI, offer immediate results. Others, such as blood work, may take a few days."
                },
                {
                    "question": "Can I skip check-ups if I feel healthy?",
                    "answer": "Even if you feel well, regular check-ups are crucial for detecting hidden conditions that may not present symptoms early on."
                }
            ]
        }
    },
    "shared": {
        "images": {
            "main": "https://dev-elite.s3.me-central-1.amazonaws.com/wp-content/uploads/2024/10/blood-test-in-dubai-1dd-2-scaled.jpg",
            "beforeAfter": []
        },
        "product": {
            "id": 16,
            "title": "General Health Check Up Package",
            "description": "Comprehensive health screening with blood tests and vital sign monitoring for preventive care",
            "price": 800
        }
    },
    "ar": {
        "url": "general-health-check-up",
        "meta": {
            "title": "باقة الفحص الطبي العام في دبي | ايليت بودي هوم",
            "description": "باقة فحص طبي شامل تشمل تحاليل الدم، تحليل البول، وفحوصات العلامات الحيوية للكشف المبكر عن المشكلات الصحية والرعاية الوقائية.",
            "robots": "index, follow",
            "canonical": "https://www.elitebodyhome.com/ar/services/general-health-check-up",
            "og": {
                "title": "باقة الفحص الطبي العام في دبي | ايليت بودي هوم",
                "description": "فحص صحي شامل مع تحاليل الدم ومراقبة العلامات الحيوية للرعاية الوقائية",
                "image": "https://www.elitebodyhome.com/images/general-health-check-og-ar.jpg"
            }
        },
        "breadcrumbs": ["الرئيسية", "الخدمات", "باقة الفحص الطبي العام"],
        "hero": {
            "title": "باقة الفحص الطبي العام",
            "subtitle": "صحتك أولويتنا",
            "description": "يُعد الفحص الطبي العام خطوة أساسية للحفاظ على صحتك ومتابعة حالتك بشكل دوري. يشمل هذا الفحص عادةً فحوصات الدم التي تساعد الأطباء على الكشف المبكر عن أي مشكلات صحية قد لا تكون ظاهرة، كما تتيح الفحوصات الدورية مراقبة مؤشراتك الحيوية واكتشاف أي تغيرات غير طبيعية في وقت مبكر. اجعل صحتك أولوية من خلال هذه الفحوصات الروتينية، وفحص الدم الشامل، لدعم نمط حياة صحي يدوم طويلًا."
        },
        "howItWorks": {
            "title": "ما الذي تتضمنه باقة الفحوصات الطبية لدينا؟",
            "description": "تشمل باقة الفحص الطبي لدينا مجموعة شاملة من التحاليل لتقييم حالتك الصحية بشكل كامل.",
            "items": [
                "تحليل قياس السكر بعد الأكل، 82947",
                "تحليل الهيموغلوبين السكري، 83036",
                "تحليل البراز، 87177",
                "تحليل البول، 81001",
                "تحليل اليوريا في الدم، 84520",
                "تحليل حمض اليوريك، 84550",
                "تحليل الكرياتينين، 82565",
                "تحليل الصوديوم في الدم، 84295",
                "تحليل البوتاسيوم في الدم، 84132",
                "تحليل الكلوريد في الدم، 82435",
                "تحليل البروتين الكلي في الدم، 84155",
                "تحليل الألبومين، 82040",
                "تحليل الجلوبيولين",
                "تحليل البيليروبين الكلي، 82247",
                "تحليل البيليروبين المباشر (المقترن)، 82248",
                "تحليل الكالسيوم، 82310",
                "تحليل الفوسفات، 84100",
                "تحليل الفوسفاتاز القلوي، 84075",
                "تحليل إنزيم ناقلة أمين الألانين، 84460",
                "تحليل إنزيم ناقلة امين الاسبارتات، 84450",
                "تحليل إنزيم ناقل الغاما غلوتاميل، 82977",
                "تحليل الدهون الكامل، 0",
                "تحليل الغدة الدرقية، 84443",
                "تحليل مستوى ثلاثي يودوثيرونين، 84481",
                "تحليل الثيروكسين الحر، 84439",
                "تحليل الأميليز، 82150",
                "تحليل الليباز، 83690",
                "تحليل البيكربونات، 82374"
            ]
        },
        "procedureSteps": {
            "heading": "إجراءات الفحص الطبي العام",
            "para": "يشمل الفحص الطبي العام عدة خطوات تهدف إلى تقييم حالتك الصحية بشكل شامل، واكتشاف أي مؤشرات مبكرة للأمراض، وتقديم الرعاية الوقائية الملائمة، مع إرشادك نحو نمط حياة صحي. إليك ما يتضمنه:",
            "steps": [
                {
                    "title": "الاستشارة الطبية",
                    "desc": "ناقش مع الطبيب تاريخك الصحي، ونمط الحياة، والأعراض أو المخاوف الصحية.",
                    "icon": "fa-solid fa-comment-medical"
                },
                {
                    "title": "الفحص السريري",
                    "desc": "يتضمن تقييم العلامات الحيوية مثل ضغط الدم، ومعدل ضربات القلب، وقياس مؤشر كتلة الجسم (BMI).",
                    "icon": "fa-solid fa-stethoscope"
                },
                {
                    "title": "الفحوصات الطبية",
                    "desc": "تشمل اختبارات الدم والبول مثل صورة دم كاملة (CBC)، وفحص سكر الدم، والكوليسترول، ووظائف الكبد والكلى، واختبارات الغدة الدرقية.",
                    "icon": "fa-solid fa-flask"
                },
                {
                    "title": "الفحوصات المتخصصة",
                    "desc": "تتضمن فحص السكري، أو ارتفاع ضغط الدم، أو أمراض نمط الحياة الأخرى.",
                    "icon": "fa-solid fa-search"
                },
                {
                    "title": "خطة صحية مخصصة",
                    "desc": "يتم وضع خطة صحية بناءً على نتائج الفحص.",
                    "icon": "fa-solid fa-clipboard-list"
                },
                {
                    "title": "التصوير التشخيصي",
                    "desc": "قد يوصي الطبيب بإجراء أشعة سينية، أو تصوير بالموجات فوق الصوتية، أو تخطيط القلب الكهربائي (ECG).",
                    "icon": "fa-solid fa-x-ray"
                },
                {
                    "title": "مراجعة النتائج مع الطبيب",
                    "desc": "يتم مناقشة نتائج التحاليل مع الطبيب المتخصص، مع شرح مفصل وتوصيات واضحة.",
                    "icon": "fa-solid fa-user-md"
                },
                {
                    "title": "المتابعة",
                    "desc": "إذا لزم الأمر، يتم تحديد مواعيد لفحوصات إضافية أو استشارات تخصصية أخرى.",
                    "icon": "fa-solid fa-calendar-check"
                }
            ]
        },
        "benefits": {
            "heading": "الفوائد",
            "subheading": "",
            "para": "يوفر الفحص الطبي العام العديد من الفوائد التي تساعد في الحفاظ على صحتك والوقاية من الأمراض. إليك أبرز الفوائد التي يقدمها:",
            "items": [
                {
                    "title": "الكشف المبكر عن الأمراض",
                    "desc": "يساعد على اكتشاف مشكلات صحية مثل أمراض القلب، والسكري، والسرطان في مراحلها الأولى، مما يُعزز فرص العلاج الفعال قبل تفاقمها.",
                    "icon": "fa-solid fa-earlybirds"
                },
                {
                    "title": "الوقاية من الأمراض المزمنة",
                    "desc": "من خلال المتابعة الدورية، يمكنك مراقبة المؤشرات الحيوية واتخاذ الإجراءات اللازمة لتفادي الإصابة بأمراض مزمنة على المدى الطويل.",
                    "icon": "fa-solid fa-shield-alt"
                },
                {
                    "title": "نصائح شخصية مخصصة",
                    "desc": "تحصل على إرشادات صحية مبنية على حالتك، تشمل النظام الغذائي، والنشاط البدني، وإدارة التوتر بما يتناسب مع نمط حياتك.",
                    "icon": "fa-solid fa-user-edit"
                },
                {
                    "title": "راحة البال",
                    "desc": "يساعد معرفة حالتك الصحية بشكل منتظم على تقليل القلق ويمكنك من تبني أسلوب حياة وقائي.",
                    "icon": "fa-solid fa-smile"
                }
            ]
        },
        "eligibility": {
            "heading": "الأهلية",
            "subheading": "",
            "para": "يُناسب الفحص الطبي العام معظم الأشخاص، لكن هناك عوامل محددة تؤثر في عدد مرات الفحص ونوع التحاليل المطلوبة.",
            "items": [
                {
                    "title": "البالغون",
                    "desc": "يُوصى بإجراء فحص طبي شامل سنويًا، خصوصًا لمن تجاوزوا سن الأربعين.",
                    "icon": "fa-solid fa-user"
                },
                {
                    "title": "الأطفال",
                    "desc": "يجب أن يخضع الأطفال لفحوصات دورية لمتابعة النمو والتطور الجسدي والعقلي.",
                    "icon": "fa-solid fa-child"
                },
                {
                    "title": "كبار السن",
                    "desc": "يحتاج كبار السن إلى فحوصات طبية أكثر تكرارًا لمتابعة حالات مثل ارتفاع ضغط الدم، أو التهابات المفاصل، أو مشكلات في البصر.",
                    "icon": "fa-solid fa-wheelchair"
                },
                {
                    "title": "الأشخاص المصابون بأمراض مزمنة",
                    "desc": "قد يحتاج مرضى السكري، أو ارتفاع ضغط الدم، أو أي حالات مزمنة أخرى إلى فحوصات دورية دقيقة لمراقبة استقرار حالتهم.",
                    "icon": "fa-solid fa-heartbeat"
                }
            ]
        },
        "preparationTips": {
            "heading": "الاستعداد",
            "subheading": "",
            "para": "يساعد الاستعداد للفحص الطبي العام في جعل الإجراء أكثر سلاسة ومساعدة الطبيب على تقييم حالتك الصحية بدقة. إليك أهم الخطوات:",
            "items": [
                {
                    "title": "الصيام",
                    "desc": "قد يُطلب منك الصيام لمدة تتراوح بين 8 إلى 12 ساعة قبل موعد الفحص، لإجراء بعض التحاليل مثل نسبة السكر في الدم أو الكوليسترول.",
                    "icon": "fa-solid fa-hourglass-half"
                },
                {
                    "title": "إحضار السجلات الطبية",
                    "desc": "احرص على إحضار أي تقارير أو تحاليل طبية سابقة، خاصةً إذا كنت تزور طبيبًا جديدًا.",
                    "icon": "fa-solid fa-folder-open"
                },
                {
                    "title": "قائمة بالأدوية",
                    "desc": "أعد قائمة بجميع الأدوية والمكملات الغذائية التي تتناولها، حتى يأخذها الطبيب بعين الاعتبار عند وضع خطة العلاج.",
                    "icon": "fa-solid fa-prescription-bottle-alt"
                },
                {
                    "title": "تدوين الأعراض",
                    "desc": "إذا كنت تعاني من أعراض معينة أو لديك مخاوف صحية، قم بتدوينها وناقشها مع الطبيب خلال الاستشارة.",
                    "icon": "fa-solid fa-clipboard-list"
                }
            ]
        },
        "results": {
            "heading": "النتائج",
            "subheading": "",
            "para": "سيقوم الطبيب بمراجعة نتائج التحاليل والفحوصات ويوجهك للخطوات التالية، إن وجدت، بعد انتهاء الفحص الطبي العام. إليك ما يمكنك توقعه:",
            "items": [
                {
                    "title": "نتائج الفحوصات",
                    "desc": "ستحصل على تقرير مفصل يحتوي على نتائج تحاليل الدم، أو الأشعة، أو أي فحوصات أُجريت خلال الفحص العام.",
                    "icon": "fa-solid fa-file-medical"
                },
                {
                    "title": "نصائح طبية",
                    "desc": "سيقدم لك الطبيب إرشادات للحفاظ على صحتك أو تحسينها بناءً على النتائج.",
                    "icon": "fa-solid fa-comment-medical"
                },
                {
                    "title": "المتابعة",
                    "desc": "قد يُطلب منك تحديد مواعيد متابعة لإجراء فحوصات إضافية أو بدء علاج مناسب في حال اكتشاف أي مؤشرات غير طبيعية.",
                    "icon": "fa-solid fa-calendar-check"
                },
                {
                    "title": "توصيات نمط الحياة",
                    "desc": "ستتلقى نصائح شخصية تتعلق بالنظام الغذائي، والتمارين الرياضية، وعادات الحياة اليومية لتحسين صحتك العامة.",
                    "icon": "fa-solid fa-heart"
                }
            ]
        },
        "aftercareTips": {
            "heading": "لماذا تختار عيادات ايليت بودي هوم لإجراء الفحص الطبي العام؟",
            "subheading": "",
            "para": "في ايليت بودي هوم، صحتك تأتي أولاً. نوفر لك فحوصات شاملة ومخصصة، تُجرى على يد فريق طبي محترف يتمتع بخبرة طويلة في مجال الرعاية الصحية. تشمل تقييماتنا الدقيقة قياس العلامات الحيوية، وتحاليل الدم، واستشارات طبية تمنحك صورة كاملة عن حالتك الصحية. نستخدم أحدث أجهزة التشخيص لضمان نتائج سريعة وموثوقة ودقيقة، مما يساهم في الكشف المبكر عن المشكلات الصحية قبل أن تتفاقم، كما ستحصل على نصائح صحية مخصصة، مما يجعل عيادات ايليت بودي هوم الخيار المثالي للعناية الاستثنائية في فحوصاتك الصحية.",
            "items": []
        },
        "faqData": {
            "heading": "الأسئلة المتكررة",
            "subheading": "",
            "items": [
                {
                    "question": "كم مرة يجب أن أخضع للفحص الطبي العام؟",
                    "answer": "يُنصح البالغون عادةً بإجراء فحص طبي عام مرة واحدة في السنة، لكن يمكن أن تختلف هذه المدة حسب العمر، ونمط الحياة، ووجود حالات صحية مزمنة."
                },
                {
                    "question": "ما هي التحاليل التي يتم إجراؤها خلال الفحص العام؟",
                    "answer": "تشمل التحاليل الأساسية عادةً فحوصات الدم، وتحليل البول، وفحوصات للكشف المبكر عن أمراض مثل السرطان، والسكري، وأمراض القلب."
                },
                {
                    "question": "هل سأحصل على نتائج الفحوصات فورًا؟",
                    "answer": "تظهر بعض النتائج مثل قياس ضغط الدم ومؤشر كتلة الجسم (BMI) فورًا، أما نتائج تحاليل الدم فقد تستغرق بضعة أيام حتى تصدر."
                },
                {
                    "question": "هل يمكنني تخطي الفحوصات إذا كنت أشعر أنني بصحة جيدة؟",
                    "answer": "حتى وإن لم تكن لديك أعراض، فإن الفحوصات المنتظمة ضرورية لاكتشاف الحالات الصحية الكامنة التي قد لا تُظهر أي علامات في المراحل المبكرة."
                }
            ]
        }
    }
}